export default __webpack_public_path__ + "static/media/telegram.aaedf8b5.svg";